import video from './autocomplete/video.store.js';

export default {
  namespaced: true,
  modules: {
    video // @todo: этот модуль лучше перенести в модуль project, а не autocomplete, т.к.
      // в модуле autocomplete будут расположены модули для компонентов типа RemoteModelAutocomplete
  }
};
